import React from "react";

function Stat({ label, value, sub, breathe }) {
  return (
    <div className="flex flex-col gap-2">
      <div className="text-[10px] tracking-[0.3em] uppercase text-[#526357]">
        {label}
      </div>
      <div
        className={`font-serif text-4xl md:text-5xl text-[#1C241F] leading-none ${
          breathe ? "breathe inline-block" : ""
        }`}
      >
        {value}
      </div>
      {sub && <div className="text-sm italic text-[#526357]">{sub}</div>}
    </div>
  );
}

export default function PlanetaryPulse({ pulse, loading }) {
  if (loading || !pulse) {
    return (
      <section
        id="pulse"
        className="max-w-7xl mx-auto px-6 md:px-12 py-24"
        data-testid="planetary-pulse-loading"
      >
        <div className="text-[10px] tracking-[0.35em] uppercase text-[#526357] mb-6">
          ⟡ planetary pulse
        </div>
        <div className="h-40 glass rounded-3xl animate-pulse" />
      </section>
    );
  }

  return (
    <section
      id="pulse"
      className="max-w-7xl mx-auto px-6 md:px-12 py-24"
      data-testid="planetary-pulse"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
        <div className="md:col-span-4">
          <div className="text-[10px] tracking-[0.35em] uppercase text-[#526357] mb-4">
            ⟡ planetary pulse
          </div>
          <h2 className="font-serif text-3xl md:text-4xl leading-tight text-[#1C241F]">
            what the&nbsp;Earth is whispering, right now.
          </h2>
          <p className="mt-6 text-sm text-[#526357] leading-relaxed">
            Each round opens with a listening. The grove tunes into Earth's
            faint resonance, her geomagnetic moods, and the warmth she carries
            in her body.
          </p>
        </div>

        <div className="md:col-span-8">
          <div className="glass rounded-3xl p-8 md:p-12 grain relative">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
              <Stat
                label="Schumann"
                value={`${pulse.schumann_hz} Hz`}
                sub={pulse.schumann_note}
                breathe
              />
              <Stat
                label="Geomagnetic Kp"
                value={pulse.kp_index.toFixed(1)}
                sub={pulse.kp_state}
              />
              <Stat
                label="Temp anomaly"
                value={`+${pulse.temp_anomaly_c.toFixed(2)}°`}
                sub={pulse.climate_note}
              />
              <Stat label="Moon" value="●" sub={pulse.moon_phase} />
            </div>

            <div className="mt-10 pt-6 border-t border-[#d8d3c4] text-[11px] text-[#526357] tracking-wide">
              {pulse.source_notes.map((n, i) => (
                <span key={i} className="mr-4">
                  · {n}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
